export const MOBILE_MAX = 767;
export const TABLET_MAX = 1023;

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

export const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_MAX}px)`;
export const TABLET_MEDIA_QUERY = `(min-width: ${
  MOBILE_MAX + 1
}px) and (max-width: ${TABLET_MAX}px)`;
export const DESKTOP_MEDIA_QUERY = `(min-width: ${TABLET_MAX + 1}px)`;
